import { DisplayInputValue } from '@reapitform/dashboard-ui'
import { LoadingSkeleton } from '@reapitform/common-ui'
import React from 'react'
import { FlexContainer } from '@reapit/elements'

const ContactDetailsDisplayViewLoading: React.FC = () => {
  return (
    <FlexContainer isFlexColumn>
      <DisplayInputValue title="Phone">
        <LoadingSkeleton height="1.25rem" />
      </DisplayInputValue>
      <DisplayInputValue title="Facsimile">
        <LoadingSkeleton height="1.25rem" />
      </DisplayInputValue>
      <DisplayInputValue title="Office Email">
        <LoadingSkeleton height="1.25rem" />
      </DisplayInputValue>
      <DisplayInputValue title="CC Email">
        <LoadingSkeleton height="1.25rem" />
      </DisplayInputValue>
      <DisplayInputValue title="Address">
        <LoadingSkeleton height="1.25rem" />
      </DisplayInputValue>
    </FlexContainer>
  )
}

export default ContactDetailsDisplayViewLoading
